import React from 'react'
import { Component } from "../../framework/components"
import MemberParticipations from './MemberParticipations'

export default class ParticipationHistory extends Component {
    view() {
        const { participation } = this.props
        return <MemberParticipations  membership={participation.membership} participation={participation} onChange={this.props.onChange} notify={this.props.notify}/>
    }
}